
import  gsap from 'gsap';
import  scrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(scrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    const sections = document.querySelectorAll('.instructions-section')

    if(sections.length < 1) return

    sections.forEach(section => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section
            }
        })

        const ingredients = section.querySelector('.ingredient-list')
        const nutrition = section.querySelector('.nutrition-area')
        const product = section.querySelectorAll('.product-instructions')
        const content = section.querySelectorAll('.recipe-content')

        let items = []

        if(ingredients) { items.push(ingredients) }
        if(content) { items = [...items, ...content] }
        if(product) { items = [...items, ...product] }
        if(nutrition) { items.push(nutrition) }

        if(items.length < 1 || !items) return

        tl.to(items, {
            stagger: 0.1,
            opacity: 1,
            translateY: 0,
            translateX: 0,
            duration: .25
        })
    })

}
